module.exports = __webpack_public_path__ + "img/ak-logo_mirror.25b56e7c.png";